import ApplicationComponent from "legacy/ApplicationComponent"
import CheckoutOverview from "legacy/boater-reservation-flow/CheckoutOverview"
import ContactInformation from "legacy/boater-reservation-flow/ContactInformation"
import SelectElectric from "legacy/boater-reservation-flow/SelectElectric"
import SignIn from "legacy/boater-reservation-flow/SignIn"
import AddBoatPageOne from "legacy/boater-reservation-flow/boat/AddBoatPageOne"
import AddBoatPageTwo from "legacy/boater-reservation-flow/boat/AddBoatPageTwo"
import SelectBoat from "legacy/boater-reservation-flow/boat/SelectBoat"
import BoatUS from "legacy/boater-reservation-flow/boatus/BoatUS"
import BoatUSToggle from "legacy/boater-reservation-flow/boatus/BoatUSToggle"
import buildPricingRequestPayload from "legacy/boater-reservation-flow/buildPricingRequestPayload"
import AddPaymentMethod from "legacy/boater-reservation-flow/credit-card/AddPaymentMethod"
import SelectPaymentMethod from "legacy/boater-reservation-flow/credit-card/SelectPaymentMethod"
import PriceEstimator from "legacy/boater-reservation-flow/price-estimate/PriceEstimator"
import SafeHarbor from "legacy/boater-reservation-flow/safe-harbor/SafeHarbor"
import SafeHarborToggle from "legacy/boater-reservation-flow/safe-harbor/SafeHarborToggle"
import {
  afterSetState,
  camelCaseToSnakeCase,
  hasAny,
  isset,
} from "legacy/helpers.es6"
import WaitlistController from "legacy/waitlist/WaitlistController"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"
import { DockwaPlusProvider } from "src/main/Account/Settings/DockwaPlusContext"
import DockwaPlusMembershipSignupModal from "src/main/Account/Settings/DockwaPlusMembershipSignupModal"

class ReservationFlowController extends ApplicationComponent {
  constructor(props) {
    super(props)

    const endDate = isset(this.props.marina.endDate)
      ? this.props.marina.endDate
      : moment().add(1, "years").format("L")
    const startDate =
      this.props.marina.startDate == null ||
      moment().isAfter(moment(this.props.marina.startDate, "L"))
        ? moment().format("L")
        : this.props.marina.startDate

    let { firstName, lastName } = this.props.user
    if (!firstName && !lastName && this.props.user.fullName) {
      const components = this.props.user.fullName.split(" ")

      firstName = components.shift()
      lastName = components.join(" ")
    }

    const { androidRequest, useDockwaPlusPricing, whiteLabel, promoCode } =
      this.props
    const {
      id: marinaId,
      dayTrip,
      boatUS,
      slug,
      terms,
      name,
      cancellationPolicy,
      multiDockage,
      verticalConstraints,
      brewerLocation,
      mbm,
    } = this.props.marina
    const {
      id: userId,
      fullName,
      phone,
      boats,
      paymentMethods,
      dockwaBalanceAmount,
      verifiedBoatUS,
      verifiedBrewer,
      brewerId,
    } = this.props.user

    this.state = {
      page: "PriceEstimator",
      header: "",
      boatType: "power",
      androidRequest,
      initialPriceEstimate: false,
      estimateBtnPressed: false,
      marinaStartDate: startDate,
      marinaEndDate: endDate,
      offerDayTrip: dayTrip,
      offerBoatUS: boatUS,
      userId,
      fullName,
      phone,
      userBoats: boats,
      paymentMethods,
      paymentMethodCards: paymentMethods.filter(
        (paymentMethod) => paymentMethod.type === "PaymentMethod::Card"
      ),
      marinaSlug: slug,
      marinaTAC: terms,
      marinaCP: cancellationPolicy,
      marinaID: marinaId,
      marinaName: name,
      multiDockage,
      dockType: this.setDockType(),
      verifiedBoatUS,
      brewerLocation,
      verifiedBrewer,
      verticalConstraints,
      dockwaBalanceAmount,
      firstName,
      lastName,
      nextDisabled: !!useDockwaPlusPricing,
      whiteLabel,
      promoCode: isset(promoCode) ? promoCode : null,
      mbm,
      user: this.props.user,
      brewerMemberID: brewerId,
      loa: "",
      arrival: "",
      departure: "",
      height: "",
      draft: "",
      electric_id: "",
      useDockwaPlusPricing,
      showDockwaPlusModal: false,
      csrfToken:
        document.querySelector('meta[name="csrf-token"]').content || "",
      fetchV2PriceError: null,
      fetchV2PriceEstimate: this.fetchV2PriceEstimate.bind(this),
      fetchV2PriceLoading: false,
    }

    this.priceEndpoint =
      process.env.BASE_URL + "/explore/destination/" + slug + "/prices"
    this.priceV2Endpoint =
      process.env.BASE_URL + "/explore/destination/" + slug + "/prices_v2"
    this.tripInsuranceQuoteEndpoint =
      process.env.BASE_URL +
      "/explore/destination/" +
      slug +
      "/trip_insurance_quote"
    this.reserveEndpoint =
      isset(this.props.whiteLabel) && this.props.whiteLabel === true
        ? process.env.BASE_URL + "/explore/destination/" + slug + "/create"
        : process.env.BASE_URL + "/explore/destination/" + slug + "/reserve"
    this.blackoutEndpoint =
      process.env.BASE_URL + "/explore/destination/" + slug + "/blackouts"
    this.navigationStack = ["PriceEstimator"]
    this.amplitudeState = ["PriceEstimator"]
    this.setBlackoutDates = this.setBlackoutDates.bind(this)
    this.setGlobalState = this.setGlobalState.bind(this)
    this.route = this.route.bind(this)
    this.routeDirect = this.routeDirect.bind(this)
    this.routeBack = this.routeBack.bind(this)
    this.setHeader = this.setHeader.bind(this)
    this.routeTo = this.routeTo.bind(this)
    this.removeCardStack = this.removeCardStack.bind(this)
    this.handleOpenDockwaPlusModal = this.handleOpenDockwaPlusModal.bind(this)
    this.handleCloseDockwaPlusModal = this.handleCloseDockwaPlusModal.bind(this)
    this.handleSetPaymentMethods = this.handleSetPaymentMethods.bind(this)
    this.handleDockwaPlusPurchaseSuccess =
      this.handleDockwaPlusPurchaseSuccess.bind(this)
    this.fetchV2PriceEstimate = this.fetchV2PriceEstimate.bind(this)
    this.resetNavigationStack = this.resetNavigationStack.bind(this)
    this.removeSignInStack = this.removeSignInStack.bind(this)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.paymentMethods !== prevState.paymentMethods) {
      this.setState({
        paymentMethodCards: this.state.paymentMethods.filter(
          (paymentMethod) => paymentMethod.type === "PaymentMethod::Card"
        ),
      })
    }

    // If the page changed, update the header visibility
    if (prevState.page !== this.state.page) {
      this.props.hideHeader(this.state.page !== "PriceEstimator")
    }
  }

  componentDidMount() {
    if (hasAny(this.props.user.paymentMethods)) {
      this.setState({
        selectedPaymentMethod: this.props.user.paymentMethods[0],
        paymentMethodCreated: "previously",
      })
    }
  }

  setDockType() {
    if (this.props.marina.multiDockage) {
      return "Mooring"
    } else {
      if (this.props.marina.docks) {
        return "Dock"
      } else {
        return "Mooring"
      }
    }
  }

  setBlackoutDates(blackouts) {
    const shiftedDates = this.shiftedDates(blackouts)
    this.setState({
      arrivalBlackouts: blackouts,
      departureBlackouts: shiftedDates,
      shiftedDepartureBlackouts: shiftedDates,
    })
  }

  relevantElectricRates() {
    if (this.props.marina.mbm) {
      return this.durationRelevantElectric()
    } else {
      return this.props.marina.electricRates
    }
  }

  durationRelevantElectric() {
    if (!this.state.arrival || !this.state.departure) {
      return []
    } else {
      const checkIn = moment(this.state.arrival)
      const checkOut = moment(this.state.departure)
      const durationInMonths = checkOut.diff(checkIn, "months")
      const durationRelevantPricingStructure =
        durationInMonths === 0 ? "per_day" : "per_month"

      return this.props.marina.electricRates.filter(
        (electricRate) =>
          electricRate.default_pricing_structure ===
          durationRelevantPricingStructure
      )
    }
  }

  shiftedDates(blackouts) {
    const shift = []
    for (let i = 0; i < blackouts.length; i++) {
      shift.push(moment(blackouts[i], "L").add(1, "days").format("L"))
    }
    return shift
  }

  setGlobalState(state, callback) {
    this.setState(state, callback)
  }

  routeTo(method) {
    const { page } = this.state
    const { useDockwaPlusPricing } = this.props
    if (
      useDockwaPlusPricing &&
      page === "SelectElectric" &&
      method === "back"
    ) {
      this.setState({ electric_id: "", fetchV2PriceLoading: true }, () => {
        this.fetchV2PriceEstimate()
        this.router.bind(this)(method)
      })
    } else {
      afterSetState(this.router.bind(this, method))
    }
  }

  router(method) {
    this.method = method
    this.pageSetOnce = false
    if (method === "back") {
      this.routeBack()
    } else if (method !== "next") {
      this.routeDirect(method)
    }

    switch (this.state.page) {
      case "PriceEstimator":
        if (isset(this.state.userId)) {
          if (this.state.boatCreated === "previously") {
            if (
              this.state.dockType === "Dock" &&
              this.relevantElectricRates().length > 0
            ) {
              this.routeNext("SelectElectric")
            } else if (this.toBoatUS()) {
              this.routeNext("BoatUSToggle")
            } else if (this.toSafeHarbor()) {
              this.routeNext("SafeHarborToggle")
            } else {
              this.routeNext("CheckoutOverview")
            }
          } else if (this.state.boatCreated === "now") {
            this.routeNext("AddBoatPageOne")
          } else if (isset(this.state.userBoats)) {
            this.routeNext("SelectBoat")
          } else {
            this.routeNext("AddBoatPageOne")
          }
        } else {
          this.routeNext("ContactInformation")
        }
        break

      case "ContactInformation":
        this.routeNext("AddBoatPageOne")
        break

      case "SignIn":
        if (isset(this.state.userBoats)) {
          this.routeNext("PriceEstimator", this.resetNavigationStack)
        } else {
          this.routeNext("AddBoatPageOne", this.removeSignInStack)
        }
        break

      case "AddBoatPageOne":
        this.routeNext("AddBoatPageTwo")
        break

      case "AddBoatPageTwo":
        if (
          this.state.dockType === "Dock" &&
          this.relevantElectricRates().length > 0
        ) {
          this.routeNext("SelectElectric")
        } else if (this.toBoatUS()) {
          this.routeNext("BoatUSToggle")
        } else if (this.toSafeHarbor()) {
          this.routeNext("SafeHarborToggle")
        } else {
          this.routeNext("CheckoutOverview")
        }
        break

      case "SelectBoat":
        if (
          this.state.dockType === "Dock" &&
          this.relevantElectricRates().length > 0
        ) {
          this.routeNext("SelectElectric")
        } else if (this.toBoatUS()) {
          this.routeNext("BoatUSToggle")
        } else if (this.toSafeHarbor()) {
          this.routeNext("SafeHarborToggle")
        } else {
          this.routeNext("CheckoutOverview")
        }
        break

      case "SelectElectric":
        if (this.toBoatUS()) {
          this.routeNext("BoatUSToggle")
        } else if (this.toSafeHarbor()) {
          this.routeNext("SafeHarborToggle")
        } else {
          this.routeNext("CheckoutOverview")
        }
        break

      case "BoatUSToggle":
        if (this.toSafeHarbor()) {
          this.routeNext("SafeHarborToggle")
        } else {
          this.routeNext("CheckoutOverview")
        }
        break

      case "BoatUS":
        if (this.toSafeHarbor()) {
          this.routeNext("SafeHarborToggle")
        } else {
          this.routeNext("CheckoutOverview")
        }
        break

      case "SafeHarborToggle":
        this.routeNext("CheckoutOverview")
        break

      case "SafeHarbor":
        this.routeNext("CheckoutOverview")
        break

      case "CheckoutOverview":
        if (isset(this.state.selectedPaymentMethod)) {
          this.routeNext("SelectPaymentMethod")
        } else {
          this.routeNext("AddPaymentMethod")
        }
        break

      case "AddPaymentMethod":
        this.routeNext("CheckoutOverview", this.removeCardStack)
        break

      case "SelectPaymentMethod":
        this.routeNext("CheckoutOverview", this.removeCardStack)
        break
    }
  }

  removeCardStack() {
    for (let i = this.navigationStack.length - 1; i > 0; i--) {
      if (this.navigationStack[i] !== "CheckoutOverview") {
        this.navigationStack.pop()
      } else {
        this.navigationStack.pop()
        return
      }
    }
  }

  removeSignInStack() {
    for (let i = this.navigationStack.length - 1; i > 0; i--) {
      if (this.navigationStack[i] !== "PriceEstimator") {
        this.navigationStack.pop()
      } else {
        return
      }
    }
  }

  resetNavigationStack() {
    // this.routeNext('PriceEstimator') will route us to PriceEstimator
    // if we don't clear this, we end up with two PriceEstimators in the stack
    this.navigationStack = []
  }

  maybePush(array, value) {
    if (!array.includes(value)) {
      array.push(value)
      this.trackEvent(value)
    }
    return array
  }

  route(methodTest, to, run) {
    if (methodTest === this.method && this.pageSetOnce === false) {
      this.setState({ page: to })
      this.pageSetOnce = true
      if (isset(run)) {
        run()
      }
      this.navigationStack.push(to)
      this.amplitudeState = this.maybePush(this.amplitudeState, to)
    }
    this.props.hideHeader(to !== "PriceEstimator")
  }

  routeDirect(method) {
    if (this.pageSetOnce === false) {
      this.setState({ page: method })
      this.navigationStack.push(method)
      this.amplitudeState = this.maybePush(this.amplitudeState, method)
      this.pageSetOnce = true
    }
    this.props.hideHeader(method !== "PriceEstimator")
  }

  routeNext(to, run) {
    this.route("next", to, run)
  }

  routeBack() {
    this.navigationStack.pop()
    const nextPage = this.navigationStack[this.navigationStack.length - 1]
    this.setState({
      page: nextPage,
    })
    // Explicitly set hideHeader status based on whether we're navigating to PriceEstimator
    this.props.hideHeader(nextPage !== "PriceEstimator")
    this.pageSetOnce = true
  }

  toBoatUS() {
    return this.state.offerBoatUS && !this.state.verifiedBoatUS
  }

  toSafeHarbor() {
    return this.state.brewerLocation && !this.state.verifiedBrewer
  }

  trackEvent(state) {
    const name = camelCaseToSnakeCase(state)
    Amplitude.trackEvent(`reservation_flow:${name}`, {
      marina_id: this.props.marina.mcom_id,
      marina_name: this.props.marina.name,
      embed_form: !!this.props.embedForm,
    })
  }

  backButton() {
    if (this.state.page !== "PriceEstimator") {
      return (
        <button
          id="reservationFlowBackButton"
          type="button"
          onClick={this.routeTo.bind(this, "back")}
          className="btn btn-secondary reservation-back-btn"
        >
          <i className="fa-kit fa-angle-left hidden-xs" />
          back
        </button>
      )
    }
  }

  reservationBody() {
    switch (this.state.page) {
      case "PriceEstimator":
        return (
          <div>
            <PriceEstimator
              setGlobalState={this.setGlobalState}
              setHeader={this.setHeader}
              routeTo={this.routeTo}
              priceEndpoint={this.priceEndpoint}
              useDockwaPlusPricing={this.props.useDockwaPlusPricing}
              openDockwaPlusModal={this.handleOpenDockwaPlusModal}
              priceV2Endpoint={this.priceV2Endpoint}
              blackoutEndpoint={this.blackoutEndpoint}
              boatDimensionValidationEndpoint={
                this.props.boatDimensionValidationEndpoint
              }
              setBlackoutDates={this.setBlackoutDates}
              state={this.state}
              last4WeekAvgPendingResTime={
                this.props.marina.last4WeekAvgPendingResTime
              }
              waitlistFeature={!!this.props.marina.waitlistFeature}
              whiteLabel={this.state.whiteLabel}
              marina={this.props.marina}
              experienceName={"reservation_flow"}
              embedForm={this.props.embedForm}
            />
          </div>
        )
      case "ContactInformation":
        return (
          <ContactInformation
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            fullName={this.state.fullName}
            email={this.state.email}
            phone={this.state.phone}
            state={this.state}
            marina={this.props.marina}
            embedForm={this.props.embedForm}
          />
        )
      case "SignIn":
        return (
          <SignIn
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            useDockwaPlusPricing={this.props.useDockwaPlusPricing}
            email={this.state.email}
          />
        )
      case "AddBoatPageOne":
        return (
          <AddBoatPageOne
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            boatName={this.state.boatName}
            boatMake={this.state.boatMake}
            boatModel={this.state.boatModel}
            boatType={this.state.boatType}
          />
        )
      case "SelectBoat":
        return (
          <SelectBoat
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            state={this.state}
          />
        )
      case "AddBoatPageTwo":
        return (
          <AddBoatPageTwo
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            loa={this.state.loa}
            beam={this.state.beam}
            draft={this.state.draft}
            state={this.state}
          />
        )
      case "SelectElectric":
        return (
          <SelectElectric
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            state={this.state}
            electricArray={this.relevantElectricRates()}
            priceV2Endpoint={this.priceV2Endpoint}
          />
        )
      case "BoatUSToggle":
        return (
          <BoatUSToggle
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            state={this.state}
          />
        )
      case "BoatUS":
        return (
          <BoatUS
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            state={this.state}
          />
        )
      case "SafeHarborToggle":
        return (
          <SafeHarborToggle
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            state={this.state}
          />
        )
      case "SafeHarbor":
        return (
          <SafeHarbor
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            state={this.state}
          />
        )
      case "CheckoutOverview":
        return (
          <CheckoutOverview
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            state={this.state}
            androidRequest={this.props.androidRequest}
            priceEndpoint={this.priceEndpoint}
            priceV2Endpoint={this.priceV2Endpoint}
            tripInsuranceQuoteEndpoint={this.tripInsuranceQuoteEndpoint}
            tripInsuranceAmplitudeEvents={
              this.props.tripInsuranceAmplitudeEvents
            }
            tripInsuranceSuppressionReasons={
              this.props.tripInsuranceSuppressionReasons
            }
            useDockwaPlusPricing={this.props.useDockwaPlusPricing}
            reserveEndpoint={this.reserveEndpoint}
            last4WeekAvgPendingResTime={
              this.props.marina.last4WeekAvgPendingResTime
            }
            marina={this.props.marina}
            openDockwaPlusModal={this.handleOpenDockwaPlusModal}
            embedForm={this.props.embedForm}
          />
        )
      case "AddPaymentMethod":
        return (
          <AddPaymentMethod
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
          />
        )
      case "SelectPaymentMethod":
        return (
          <SelectPaymentMethod
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            state={this.state}
          />
        )
      case "Waitlist":
        return (
          <WaitlistController
            setGlobalState={this.setGlobalState}
            setHeader={this.setHeader}
            routeTo={this.routeTo}
            state={this.state}
            verticalConstraints={this.state.verticalConstraints}
            draftMissing={this.props.draftMissing}
            heightMissing={this.props.heightMissing}
            boaterSide={true}
            user={this.props.user}
            multiDockage={this.state.multiDockage}
            spaceType={this.state.dockType}
          />
        )
    }
  }

  setHeader(title) {
    this.setState({ header: title })
  }

  header() {
    if (this.state.header) {
      return (
        <h2
          id="reservationFlowControllerHeader"
          className="text-center text-xl font-normal"
        >
          {this.state.header}
        </h2>
      )
    }
  }

  handleOpenDockwaPlusModal() {
    const {
      user: { id: userId },
    } = this.state

    if (userId) {
      this.setState({ showDockwaPlusModal: true })
    } else {
      this.routeTo("SignIn")
    }
  }

  handleCloseDockwaPlusModal() {
    this.setState({ showDockwaPlusModal: false })
  }

  handleSetPaymentMethods(updater) {
    this.setState((prevState) => {
      const updated =
        typeof updater === "function"
          ? updater(prevState.paymentMethods)
          : updater
      return {
        paymentMethods: updated,
        paymentMethodCards: updated.filter(
          (pm) => pm.type === "PaymentMethod::Card"
        ),
      }
    })
  }

  handleDockwaPlusPurchaseSuccess(data, selectedPaymentMethodId) {
    const paymentMethod = this.state.paymentMethodCards.find(
      (pm) => pm.stripePaymentMethodId === selectedPaymentMethodId
    )

    this.setGlobalState(
      {
        user: {
          ...this.state.user,
          activeDockwaPlusSubscription: true,
        },
        selectedPaymentMethod: paymentMethod,
        paymentMethodCreated: "previously",
      },
      this.fetchV2PriceEstimate
    )
  }

  handleJsonResponse(response) {
    return response
      .json()
      .catch(() => {
        return Promise.reject(new Error("Invalid JSON response"))
      })
      .then((data) => {
        if (!response.ok) {
          const errorMessage = (data && data.error) || "Unknown error"
          return Promise.reject(new Error(errorMessage))
        }
        return data
      })
  }

  fetchV2PriceEstimate() {
    const postObject = buildPricingRequestPayload(this.state)

    this.setState({ fetchV2PriceError: null, fetchV2PriceLoading: true })

    return fetch(this.priceV2Endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.state.csrfToken,
      },
      body: JSON.stringify(postObject),
    })
      .then(this.handleJsonResponse)
      .then((data) => {
        this.setState(
          {
            dockwaPlusOffer: data.dockwa_plus_offer,
            pricingSummary: data.pricing_summary,
            minimumNights: data.minimum_nights,
            pricingBreakdown: data.pricing_breakdown,
            paymentsDue: data.payments_due,
          },
          () => {
            this.setState({ fetchV2PriceLoading: false })
          }
        )
        return data
      })
      .catch((error) => {
        this.setState({
          fetchV2PriceError: error.message,
          fetchV2PriceLoading: false,
        })
        return Promise.reject(error)
      })
  }

  render() {
    const { paymentMethodCards, showDockwaPlusModal } = this.state

    return (
      <div
        id="reservationFlowController"
        className="reservation-flow-controller"
      >
        {this.backButton()}
        {this.header()}
        {showDockwaPlusModal && (
          <DockwaPlusProvider>
            <DockwaPlusMembershipSignupModal
              isOpen={showDockwaPlusModal}
              setIsOpen={(isOpen) =>
                this.setState({ showDockwaPlusModal: isOpen })
              }
              setUser={(data) => this.setGlobalState({ user: data })}
              paymentMethods={paymentMethodCards}
              setPaymentMethods={this.handleSetPaymentMethods}
              onPurchaseSuccess={this.handleDockwaPlusPurchaseSuccess}
            />
          </DockwaPlusProvider>
        )}
        <div className="reservation-body">{this.reservationBody()}</div>
      </div>
    )
  }
}

ReservationFlowController.propTypes = {
  marina: PropTypes.shape({
    id: PropTypes.number,
    mcom_id: PropTypes.string,
    name: PropTypes.string,
    slug: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    dayTrip: PropTypes.shape({
      dock: PropTypes.bool,
      mooring: PropTypes.bool,
    }),
    boatUS: PropTypes.bool,
    docks: PropTypes.bool,
    terms: PropTypes.string,
    cancellationPolicy: PropTypes.number,
    multiDockage: PropTypes.bool,
    verticalConstraints: PropTypes.object,
    brewerLocation: PropTypes.bool,
    mbm: PropTypes.bool,
    electricRates: PropTypes.array,
    last4WeekAvgPendingResTime: PropTypes.string,
    waitlistFeature: PropTypes.bool,
  }),
  user: PropTypes.shape({
    id: PropTypes.number,
    fullName: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    boats: PropTypes.array,
    paymentMethods: PropTypes.array,
    dockwaBalanceAmount: PropTypes.number,
    verifiedBoatUS: PropTypes.bool,
    verifiedBrewer: PropTypes.bool,
    brewerId: PropTypes.string,
  }),
  androidRequest: PropTypes.bool,
  useDockwaPlusPricing: PropTypes.bool,
  whiteLabel: PropTypes.bool,
  embedForm: PropTypes.bool,
  promoCode: PropTypes.object,
  hideHeader: PropTypes.func,
  draftMissing: PropTypes.bool,
  heightMissing: PropTypes.bool,
  boatDimensionValidationEndpoint: PropTypes.string,
}

export default ReservationFlowController
